// Host comparison for admin feed-alias warnings. Mirrors the backend
// `aliasHostMatchesSite` (downread/shared/src/utils/sanitize.ts): an alias whose
// host differs from the feed's site URL host is suspicious and must be flagged so
// admins don't promote a hostname the feed merely claims (e.g. a feed declaring
// microsoft.com). Alias values from the API are already scheme-less ("host[/path]");
// siteUrl is a full URL — both are reduced to a bare, www-stripped host.
export function aliasHostOf(urlOrAlias: string | undefined): string {
  if (!urlOrAlias) return '';
  return urlOrAlias.replace(/^https?:\/\//i, '').toLowerCase().split('/')[0].replace(/^www\d?\./, '');
}

/** True when the alias host differs from the feed's site URL host (a warning condition).
 *  Returns false when the site URL has no host (nothing to compare against). */
export function aliasHostMismatch(alias: string | undefined, siteUrl: string | undefined): boolean {
  const site = aliasHostOf(siteUrl);
  if (!site) return false;
  return aliasHostOf(alias) !== site;
}
